// extracted by mini-css-extract-plugin
export default {"app":"app_app__SmNHm","main":"app_main__0nq55","container":"app_container__wu4g8"};